import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jpkuster.com";
const DEFAULT_OG =
  "https://cdn.crevado.com/artists/1287474/artwork/19591622_original-1.jpg";

export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} — JP Kuster`
    : "JP Kuster — Brand & Marketing, Built to Scale";
  const desc =
    description ||
    "Senior brand & marketing leader. Building brands on connection, growing them through culture, paying in revenue. Chicago / Los Angeles.";
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_OG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="JP Kuster" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
